import { render } from "./TarifsView.vue?vue&type=template&id=98ceeaa0&scoped=true"
import script from "./TarifsView.vue?vue&type=script&lang=js"
export * from "./TarifsView.vue?vue&type=script&lang=js"

import "./TarifsView.vue?vue&type=style&index=0&id=98ceeaa0&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ceeaa0"]])

export default __exports__